import React, { useEffect, useState } from "react";
import {
  LineChart,
  XAxis,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  CartesianGrid,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";
import moment from "moment";

function DgLineChart({ data, value, title, height }) {
  const [formattedData, setFormattedData] = useState([]);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(0);
  const [totalDays, setTotalDays] = useState(0);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      const roundedHistorical = data.map((item) => ({
        ...item,
        [value]: parseFloat(item[value]).toFixed(1),
      }));

      setTotalDays(data.length);

      setFormattedData(roundedHistorical);

      setMinValue(Math.min(...data.map((d) => d[value])).toFixed(1));
      setMaxValue(Math.max(...data.map((d) => d[value])).toFixed(1));
    }
  }, [data]);

  const getMonthLabel = (data, tickItem) => {
    const tickDate = moment(tickItem);
    const currentMonth = tickDate.format("YYYY-MM");

    const firstEntryOfMonth = data.find(
      (item) => moment(item.date).format("YYYY-MM") === currentMonth
    );
    return tickDate.isSame(moment(firstEntryOfMonth.date), "day")
      ? tickDate.format("MMMM")
      : "";
  };

  const getDaysLabel = (data, tickItem) => {
    const tickDate = moment(tickItem);
    const formattedDate = tickDate.format("DD MMM");
    const currentDate = tickDate.format("DD MMM");

    if (data.length > 7) {
      const interval = Math.floor(data.length / 7);
      const tickIndex = data.findIndex((item) =>
        moment(item.date).isSame(tickItem, "day")
      );

      if (tickIndex % interval === 0) {
        return currentDate;
      } else {
        return "";
      }
    } else {
      return currentDate;
    }
  };

  const formatDate = (tickItem, totalDays, data) => {
    return totalDays > 31
      ? getMonthLabel(data, tickItem)
      : getDaysLabel(data, tickItem);
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart
        data={formattedData}
        margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
      >
        <defs>
          <linearGradient id="colorPv" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#DD5E89" stopOpacity={1} />
            <stop offset="100%" stopColor="#F7BB97" stopOpacity={1} />
          </linearGradient>
        </defs>
        <CartesianGrid
          strokeDasharray="2 2"
          vertical={false}
          stroke="#95B2C5"
        />
        <XAxis
          dataKey="date"
          tickFormatter={(tick) => formatDate(tick, totalDays, formattedData)}
          axisLine={false}
          interval={"preserveStartEnd"}
          stroke="#95B2C5"
          padding={{ left: 12, right: 12 }}
          dy={12}
        />
        <YAxis
          axisLine={false}
          stroke="#95B2C5"
          dx={-6}
          domain={[minValue, maxValue]}
          width={80}
        />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="totalEquity"
          stroke="url(#colorPv)"
          strokeWidth={2}
          name={title}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

export default DgLineChart;
